<div fxLayout="column" fxLayoutAlign="space-around flex-start" class="confirmation-wrapper p-40">
  <div class="text-wrapper mb-50">
    <div class="title text-yellow font-24 bold font-chakra">
      {{ 'construction.title' | translate }}
    </div>
    <div class="message text-white font-16 mt-15">
      <p>{{ 'construction.text1' | translate }}</p>
      <p>{{ 'construction.text2' | translate }}</p>
      <p class="text-yellow italic">{{ 'construction.text3' | translate }}</p>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center" class="actions-wrapper w-full">
    <button class="aum-button px-50" color="primary" mat-raised-button (click)="close()">
      {{ 'general.ok' | translate | uppercase }}
    </button>
  </div>
</div>